import React, { useState } from 'react';
import { createClientAdmin } from '../services/clientService';
import { Loader2 } from 'lucide-react';

const CreateAdminForm = ({ clientId, clientName, onSuccess }) => {
    const [formData, setFormData] = useState({
        email: '',
        password: '',
        username: clientName || '',
        phoneNumber: '',
        ville: ''
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        setSuccess('');

        try {
            await createClientAdmin(clientId, formData);
            setSuccess('Admin created successfully!');
            setTimeout(() => {
                if (onSuccess) onSuccess();
            }, 1500);
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to create admin');
        } finally {
            setLoading(false);
        }
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-6 bg-slate-50 p-6 border border-slate-100 rounded-md">
            {success && (
                <div className="p-4 bg-emerald-50 text-emerald-600 text-[10px] font-black uppercase tracking-widest rounded-md border border-emerald-100">
                    {success}
                </div>
            )}
            {error && (
                <div className="p-4 bg-red-50 text-red-600 text-[10px] font-black uppercase tracking-widest rounded-md border border-red-100">
                    {error}
                </div>
            )}

            <div>
                <label className="block text-[10px] font-black text-slate-500 uppercase tracking-widest mb-2">Email Administrateur</label>
                <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 bg-white border border-slate-200 text-sm focus:ring-2 focus:ring-slate-900 focus:border-transparent transition-all outline-none rounded-md"
                    placeholder="admin@domaine.com"
                />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                    <label className="block text-[10px] font-black text-slate-500 uppercase tracking-widest mb-2">Username</label>
                    <input
                        type="text"
                        name="username"
                        value={formData.username}
                        onChange={handleChange}
                        required
                        className="w-full px-4 py-3 bg-white border border-slate-200 text-sm focus:ring-2 focus:ring-slate-900 focus:border-transparent transition-all outline-none rounded-md"
                        placeholder="Identifiant"
                    />
                </div>
                <div>
                    <label className="block text-[10px] font-black text-slate-500 uppercase tracking-widest mb-2">Mot de passe</label>
                    <input
                        type="password"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        required
                        className="w-full px-4 py-3 bg-white border border-slate-200 text-sm focus:ring-2 focus:ring-slate-900 focus:border-transparent transition-all outline-none rounded-md"
                        placeholder="••••••••"
                    />
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                    <label className="block text-[10px] font-black text-slate-500 uppercase tracking-widest mb-2">Téléphone</label>
                    <input
                        type="tel"
                        name="phoneNumber"
                        value={formData.phoneNumber}
                        onChange={handleChange}
                        className="w-full px-4 py-3 bg-white border border-slate-200 text-sm focus:ring-2 focus:ring-slate-900 focus:border-transparent transition-all outline-none rounded-md"
                        placeholder="+216 00 000 000"
                    />
                </div>
                <div>
                    <label className="block text-[10px] font-black text-slate-500 uppercase tracking-widest mb-2">Ville</label>
                    <input
                        type="text"
                        name="ville"
                        value={formData.ville}
                        onChange={handleChange}
                        className="w-full px-4 py-3 bg-white border border-slate-200 text-sm focus:ring-2 focus:ring-slate-900 focus:border-transparent transition-all outline-none rounded-md"
                        placeholder="Ex: Tunis"
                    />
                </div>
            </div>

            <div className="pt-4">
                <button
                    type="submit"
                    disabled={loading}
                    className="w-full px-6 py-3 text-[10px] uppercase font-black tracking-widest bg-slate-900 text-white hover:bg-slate-800 transition-colors disabled:opacity-50 rounded-md flex justify-center items-center gap-2"
                >
                    {loading && <Loader2 className="animate-spin h-4 w-4" />}
                    {loading ? 'Création...' : 'Créer Compte'}
                </button>
            </div>
        </form>
    );
};

export default CreateAdminForm;
